import {
  useLazyGetSumsubVerificationTokenRequestQuery,
  useUserQuery,
} from '@features/api/userSlice';
import SumsubWebSdk from '@sumsub/websdk-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from './VerifyProfile.styles';
import { InvestorQualificationStage } from '@features/api/response/User';

const POLLING_INTERVAL_MINUTES = 1;

const APPLICANT_STATUS_KEY = 'idCheck.onApplicantStatusChanged';

export const VerifyProfile = () => {
  const navigate = useNavigate();

  const [startPolling, setStartPolling] = useState(false);
  const { data: user, refetch: refetchUser } = useUserQuery(undefined, {
    pollingInterval: startPolling ? POLLING_INTERVAL_MINUTES * 1000 * 60 : 0,
  });

  const [getSumsubVerificationToken, { data }] =
    useLazyGetSumsubVerificationTokenRequestQuery();
  const accessToken = data?.token;

  useEffect(() => {
    getSumsubVerificationToken({ verificationType: 'IDV' });
  }, [getSumsubVerificationToken]);

  const handleMessage = (event: string, payload: any) => {
    if (event === APPLICANT_STATUS_KEY) {
      const {
        reviewStatus,
        reviewResult: { reviewAnswer },
      } = payload;

      const isApproved =
        reviewStatus === 'completed' && reviewAnswer === 'GREEN';

      if (isApproved) {
        refetchUser();
        setStartPolling(true);
      } else {
        setStartPolling(false);
      }
    }
  };

  if (
    user?.investorQualificationStage ===
    InvestorQualificationStage.CompletedQualified
  )
    navigate('/');

  if (!accessToken) return <></>;
  return (
    <Container>
      <SumsubWebSdk
        style={{
          width: '100%',
          height: '100%',
        }}
        accessToken={accessToken}
        expirationHandler={async () => {
          const { token } = await getSumsubVerificationToken({
            verificationType: 'IDV',
          }).unwrap();
          return token;
        }}
        config={{
          uiConf: {
            customCss: window.parent.location.origin + '/VerifyProfile.css',
          },
        }}
        options={{}}
        onMessage={handleMessage}
      />
    </Container>
  );
};
